import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation.js"
import { checkPermission } from "library/authorization/index.mjs"
import DemandGuard from "minimals-template/components/guards/DemandGuard.js"
import { appRoute } from "routes/app/home.runtime.js"
import { TOOLBOX_PLUGIN_NAME, TOOLBOX_DEMANDS } from "plugins/toolbox/constants.js"
import { TabbedPage } from "routes/@lib/tabbed-page/tabbed-page.runtime.js"
import { registerTab } from "lib/@components/tabs/index.js"
import { DuplicateFinderPanel } from "plugins/toolbox/client/components/duplicate-finder-panel.js"
import { CheckExistingPanel } from "plugins/toolbox/client/components/check-existing-panel.js"
import { QuickWinPanel } from "plugins/toolbox/client/components/quick-win-panel.js"

registerConditionalPageNavigation(
    () => checkPermission(TOOLBOX_DEMANDS, true),
    "/app/toolbox",
    TOOLBOX_PLUGIN_NAME,
    "game-icons:conway-life-glider",
    {
        group: "Toolbox",
        priority: 250,
    }
)

appRoute.register(
    "toolbox",
    <DemandGuard demands={TOOLBOX_DEMANDS} and>
        <TabbedPage tabId="defect-toolbox" pageTitle="Defect Toolbox" />
    </DemandGuard>
)

registerTab({
    id: "duplicate-finder",
    tab: "defect-toolbox",
    title: "Duplicate Finder",
    content: <DuplicateFinderPanel $lazy />,
})

registerTab({
    id: "check-existing",
    tab: "defect-toolbox",
    title: "Check Existing",
    content: <CheckExistingPanel $lazy />,
})

registerTab({
    id: "quick-wins",
    tab: "defect-toolbox",
    title: "Quick Wins",
    content: <QuickWinPanel $lazy />,
})
